// src/belediye/components/utils/textFormat.js

const TR_LOCALE = "tr-TR";

/**
 * Null/undefined/boş string -> "—"
 * Diğer her şeyi trimleyip döndürür.
 */
export function safeText(v, fallback = "—") {
  if (v === null || v === undefined) return fallback;
  const s = String(v).trim();
  return s ? s : fallback;
}

/**
 * Sadece ilk harfi büyütür (geri kalanını DEĞİŞTİRMEZ).
 * - "kırıkhan belediyesi" -> "Kırıkhan belediyesi"
 * - "İBB" -> "İBB" (bozulmaz)
 */
export function ensureFirstUpperTr(input) {
  const s = safeText(input, "");
  if (!s) return "—";

  const first = s[0].toLocaleUpperCase(TR_LOCALE);
  return first + s.slice(1);
}

/**
 *   NEW: truncateText (named export)
 * - UI kartlarında/tabloda kısa gösterim için
 * - null/undefined güvenli
 */
export const truncateText = (text, maxLen = 120, suffix = "…") => {
  const s = String(text ?? "").trim();
  if (!s) return "";
  const n = Number(maxLen);
  if (!Number.isFinite(n) || n <= 0) return "";
  if (s.length <= n) return s;
  return s.slice(0, n).trimEnd() + suffix;
};
/**
 * Ad Soyad gibi alanlarda her kelimenin ilk harfini büyütür.
 * - "ahmet can" -> "Ahmet Can"
 * - "mehmet ali yılmaz" -> "Mehmet Ali Yılmaz"
 * - "oğuzhan-eren" -> "Oğuzhan-Eren"
 * - "ali'nin" -> "Ali'nin"
 *
 * Not: Kısaltmaları (IBB, T.C.) zorla küçültmez/büyütmez; olduğu gibi bırakır.
 */
export function titleCaseTr(input) {
  const raw = safeText(input, "");
  if (!raw) return "—";

  const words = raw
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => titleCaseTokenTr(w));

  return words.join(" ");
}

function titleCaseTokenTr(token) {
  // "T.C." gibi kısaltmalara dokunma
  if (looksLikeAcronym(token)) return token;

  // tire/apostrof ayrımlarını koru
  // örn: "ali'nin" veya "oğuzhan-eren"
  return token
    .split(/([-’'])/g) // ayırıcıları da tut
    .map((part) => {
      if (part === "-" || part === "'" || part === "’") return part;
      if (!part) return part;
      if (looksLikeAcronym(part)) return part;

      const first = part[0].toLocaleUpperCase("tr-TR");
      const rest = part.slice(1).toLocaleLowerCase("tr-TR");
      return first + rest;
    })
    .join("");
}

function looksLikeAcronym(s) {
  // Kısaltma kriterini DARALTIYORUZ:
  // - Nokta varsa (T.C., A.Ş.) -> kısaltma
  // - Rakam içeriyorsa (3M) -> kısaltma
  // - Sadece 2-3 harf ve tamamı büyükse (IBB, KGM) -> kısaltma
  // - Daha uzun TAMAM-BÜYÜK kelimeler (İKİZLER) kısaltma değildir -> title-case uygulanmalı

  if (!s) return false;

  const hasDot = s.includes(".");
  if (hasDot) return true;

  const hasDigit = /\d/.test(s);
  if (hasDigit) return true;

  // Harfleri çıkar (TR dahil)
  const alpha = s.replace(/[^A-Za-zÇĞİÖŞÜçğıöşüİı]/g, "");
  if (!alpha) return false;

  const isAllUpper = alpha === alpha.toLocaleUpperCase(TR_LOCALE);

  // 2-3 harfli ALL CAPS ise kısaltma say
  if (isAllUpper && alpha.length <= 3) return true;

  return false;
}

/**
 * İsim Soyisim için özel helper (veri parçalı gelirse)
 * first/last boşsa username/email'e düşebilir (sayfa mantığına göre).
 */
export function formatPersonNameTr(user) {
  if (!user) return "—";
  const first = safeText(user.first_name, "");
  const last = safeText(user.last_name, "");
  const full = `${first} ${last}`.trim();

  if (full) return titleCaseTr(full);

  // fallback (gösterim tercihinize göre)
  return safeText(user.username || user.email);
}
